import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import IconBox from "./IconBox";

export default function CategoryCard({ icon, title, desc, items = [], to }) {
  return (
    <div className="card-premium p-5 h-full flex flex-col" data-testid={`category-${title}`}>
      <div className="flex items-center gap-3 mb-3">
        <IconBox name={icon} />
        <h3 className="font-bold text-navy text-base leading-tight">{title}</h3>
      </div>
      <p className="text-sm text-[var(--melopa-muted)] mb-3">{desc}</p>
      {items.length > 0 && (
        <ul className="text-sm text-[var(--melopa-text)] space-y-1 mb-4">
          {items.slice(0, 5).map((it) => (
            <li key={it} className="flex items-start gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-[var(--melopa-gold)] mt-2" />
              <span>{it}</span>
            </li>
          ))}
        </ul>
      )}
      {to && (
        <Link to={to} className="mt-auto inline-flex items-center gap-1 text-sm font-semibold text-navy hover:gap-2 transition-all">
          Learn more <ArrowRight className="w-4 h-4" />
        </Link>
      )}
    </div>
  );
}
